import { type AuthUser } from '../../../../hooks/use-auth'
import { AuthFunctions, hasPermission } from '../../../../utils/permissions'

const ADMINISTRATIVE_FUNCTIONS = [
  AuthFunctions.PROJECT_SETTINGS,
  AuthFunctions.RCN_MANAGEMENT,
  AuthFunctions.ISD_MANAGEMENT,
  AuthFunctions.DISTRICT_MANAGEMENT,
  AuthFunctions.RCN_ADMINISTRATION,
  AuthFunctions.ISD_ADMINISTRATION,
  AuthFunctions.DISTRICT_ADMINISTRATION
]

export interface MembershipCapabilities {
  canEditBuildings: boolean
  canEditRole: boolean
  canEditFunctions: boolean
  canRemove: boolean
}

export const isUserAdministrator = (user: AuthUser | null): boolean =>
  user != null && ADMINISTRATIVE_FUNCTIONS.some((f) => hasPermission(user, f))

/**
 * A membership is granted by an organization's administrator and never owned by its holder, so
 * viewing your own confers no edit capability over it. The exception is a membership being created:
 * an administrator may add themselves to an organization they already administer — that is how they
 * join a district to participate in CETA — and must be able to set its buildings, role and functions
 * as they add it. An existing membership of their own stays read-only, so they cannot strand
 * themselves, and the server refuses the write besides.
 */
export const capabilitiesForMembership = (
  isSelf: boolean,
  isAdmin: boolean,
  isNewMembership: boolean
): MembershipCapabilities => ({
  canEditBuildings: isAdmin && (!isSelf || isNewMembership),
  canEditRole: isAdmin && (!isSelf || isNewMembership),
  canEditFunctions: isAdmin && (!isSelf || isNewMembership),
  canRemove: isAdmin && !isSelf
})
